const MS_PER_DAY = 1000 * 60 * 60 * 24

export const parseDateOnly = (value: string | null | undefined) => {
  if (!value) return null

  const datePart = value.split('T')[0]
  const [yearStr, monthStr, dayStr] = datePart.split('-')

  const year = Number(yearStr)
  const month = Number(monthStr)
  const day = Number(dayStr)

  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return null
  }

  return new Date(year, month - 1, day)
}

const startOfLocalDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate())

export const formatDateOnly = (
  value: string | null | undefined,
  locale: string | undefined,
  options: Intl.DateTimeFormatOptions,
) => {
  const parsedDate = parseDateOnly(value)
  if (!parsedDate) return null

  return parsedDate.toLocaleDateString(locale, options)
}

export const getDateOnlyDiffInDays = (value: string | null | undefined, fromDate = new Date()) => {
  const targetDate = parseDateOnly(value)
  if (!targetDate) return null

  const diffMs = startOfLocalDay(targetDate).getTime() - startOfLocalDay(fromDate).getTime()
  return Math.floor(diffMs / MS_PER_DAY)
}
